import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { myWorksheets } from "@/lib/api";

function groupByModule(items, lang) {
  const filtered = items.filter((w) => !w.language || w.language === lang);
  const map = {};
  for (const w of filtered) {
    const key = w.module || "—";
    (map[key] = map[key] || []).push(w);
  }
  const groups = Object.entries(map).map(([module, list]) => {
    list.sort((a, b) => String(a.training_date || "").localeCompare(String(b.training_date || "")));
    const minDate = list.map((x) => x.training_date || "").filter(Boolean).sort()[0] || "";
    return { module, list, minDate };
  });
  groups.sort((a, b) => String(a.minDate).localeCompare(String(b.minDate)) || a.module.localeCompare(b.module));
  return groups;
}

export default function Worksheets() {
  const { lang } = useApp();
  const t = useAppUi(lang);
  const [items, setItems] = useState(null);
  useEffect(() => { myWorksheets().then(setItems).catch(() => setItems([])); }, []);

  const groups = items ? groupByModule(items, lang) : [];

  return (
    <PLayout>
      <h1 className="rbl-h1" style={{ fontSize: 36 }}>📝 {t("wsTitle")}</h1>
      <p className="rbl-intro">{t("wsIntro")}</p>
      <div style={{ marginTop: 24 }} data-testid="worksheet-list">
        {items === null && <div className="rbl-spinner" />}
        {items && groups.length === 0 && <p style={{ color: "var(--muted)" }}>{t("wsNone")}</p>}
        {groups.map((g) => (
          <div key={g.module} style={{ marginBottom: 28 }} data-testid={`worksheet-group-${g.module}`}>
            <h2 className="rbl-section-title" style={{ marginBottom: 12 }}>{g.module}</h2>
            {g.list.map((w) => (
              <Link key={w.id} to={`/app/worksheets/${w.id}`} className="rbl-list-item" data-testid={`worksheet-item-${w.id}`}>
                <div>
                  <div style={{ fontWeight: 700 }}>{w.title}</div>
                  <div style={{ color: "var(--muted)", fontSize: 13 }}>{w.training_date || w.description || `${(w.fields || []).length} ${t("questions")}`}</div>
                </div>
                <span className={`rbl-badge ${w.submission ? "ok" : "todo"}`}>{w.submission ? t("badgeSaved") : t("badgeTodo")}</span>
              </Link>
            ))}
          </div>
        ))}
      </div>
    </PLayout>
  );
}
